import { create } from "zustand";

export const useLanguageStore = create((set) => ({
  lang: "ko",
  setLang: (lang) => set({ lang }),
}));
